import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import image2 from "../Images/movie-inside7.png";
import video from "../Images/movie2.mp4";
import Arrow from "../Images/left.png";
const PageSeven = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Trigger the animation when the component mounts
    setAnimate(true);
  }, []);
  const captions = [
    "This action-packed film showcases a fight for the last Dorito. It takes a twist when the stakes are high."
  ];
  const castMembers = [

    "Alex Metaxas",
    "Elijah Newbury",
    
  ];
  const crewMembers = [
 "Director – Alex Metaxas", 
"Screenplay – Alex Metaxas & Elijah Newbury", 
"Director of Photography – Clint Thambi",   
"Camera Assistant – Izac De Castro", 
"Sound recordist – Jae Hulbert", 
"Gaffer – Claudia Jones", 
"Location Manager- Liam Vaughan", 
"Editor – Alex Metaxas", 
"Make up – Abby Dodd" 
];

  return (
    <>
      <Container className="parallexScroll">
        <div className={`gallery ${animate ? "zoom-in" : ""}`}>
          {[image2, video, image2,image2].map((item, index) => (
            <div className="pinned-image" key={index}>
              {index === 1 ? (
                <video
                  className="video-responsive"
                  loop
                  autoPlay
                  playsInline
                  muted={true} // Allows the video to play with sound
                  controls // Optional, if you want to give users play/pause controls
                  style={{ cursor: "pointer"}}
                >
                  <source
                    src="../Videos/movie7.mp4"
                    type="video/mp4"
                  />
                </video> // Video element for second item
              ) : (
                <img
                  src={item}
                  alt={`Item ${index + 1}`}
                  className="img-fluid w-100"
                />
              )}
             {index !== 1 && index !== 2 && (
                <div className="caption">{captions[index]}</div>
              )}
              {/* Third Slide: Cast Section */}
              {index === 2 && (
                <div className="caption">
                  
                  <div className="castCrewContainer">
                    {/* Cast Section */}
                    <div className="castSection">
                      
                    </div>

                    {/* Crew Section */}
                    <div className="crewSection">
                    <h6>Cast</h6>
                      {castMembers.map((member, idx) => (
                        <h5 key={idx}>{member}</h5>
                      ))}
                    </div>
                </div>
                </div>
              )}
              {index === 3 && (
                <div className="caption">
                  
                  <div className="castCrewContainer">
                   {/* Crew Section */}
                  
                    <div className="castSection">
                    </div>
                    <div className="crewSection">
                    <h6>Crew</h6>
                      {crewMembers.map((member, idx) => (
                        <h5 key={idx}>{member}</h5>
                      ))}
                    </div>
                </div>
                
                </div>
              )}


            </div>
          ))}
        </div>
        <div
        className="back-arrow"
        onClick={() => window.history.back()} // Navigate back on click
      >
       <img src={Arrow} alt="Placeholder"/> {/* Unicode left arrow */}
      </div>
      </Container>
    </>
  );
};

export default PageSeven;
